import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Translations from 'Placements/Configs/Language/Translation'

i18n.use(initReactI18next)
    .init({
        resources:{
            en: Translations.en,
            es: Translations.es,
        },
        lng: 'en',
        keySeparator: false,
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;